import styled from "styled-components";
import BREAKPOINTS from "../../Theme/Breakpoints";
import COLORS from "../../Theme/Colors";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  max-width: 1412px;
  border-radius: 1rem;
  height: 60vh;
  background-image: linear-gradient(-20deg, #d558c8 0%, #24d292 100%);

  ${BREAKPOINTS.TABLET} {
    padding: 0 3rem;
    margin: 0 2rem;
  }

  ${BREAKPOINTS.MOBILE} {
    padding: 0 3rem;
    height: 48vh;
    border-radius: 0;
  }
`;

export const Title = styled.div`
  max-width: 1080px;
  text-align: center;
  line-height: 4rem;
  margin: auto;

  h1 {
    margin: 0;
    color: ${COLORS.white};
    font-family: "Poppins", sans-serif;
    font-size: 3.5rem;
    font-weight: 600;

    ${BREAKPOINTS.TABLET} {
      font-size: 2.5rem;
      text-align: center;
    }

    ${BREAKPOINTS.MOBILE} {
      font-size: 2rem;
      text-align: center;
      line-height: 2.5rem;
    }
  }
`;
